var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInOverstay = function SvgInOverstay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.8658 14 14 10.8675 14 7C14 3.1325 10.8658 0 7 0C3.13425 0 0 3.1325 0 7C0 10.8675 3.13425 14 7 14ZM7.65625 2.625C7.65625 2.26625 7.36225 1.96875 7 1.96875C6.63775 1.96875 6.34375 2.26625 6.34375 2.625V7C6.34375 7.35875 6.63775 7.65625 7 7.65625H10.5C10.8623 7.65625 11.1562 7.35875 11.1562 7C11.1562 6.64125 10.8623 6.34375 10.5 6.34375H7.65625V2.625Z",
    fill: "currentColor"
  })));
};
export default __webpack_public_path__ + "assets/5423ad47ca122074f45d3a33545dc0bd.svg";
export { SvgInOverstay as ReactComponent };


// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Status/assets/icons/in_overstay.svg